import { BatchOperationType } from '@repo/contracts/common';
import { BatchOperationStatus } from '@repo/contracts/tenant-api';

/** Statuses that indicate a batch operation is still in progress. */
export const ACTIVE_STATUSES: BatchOperationStatus[] = [
  BatchOperationStatus.PENDING,
  BatchOperationStatus.PROCESSING,
];

/**
 * Maps batch operation type strings to i18n translation key segments.
 * Used by the processing banner, sidebar shortcut, and lock context.
 */
export const OPERATION_TYPE_KEY_MAP: Record<string, string> = {
  [BatchOperationType.FLIGHT_STATUS_REFRESH]: 'flightStatusRefresh',
  [BatchOperationType.FLIGHT_LIST_IMPORT_PIPELINE]: 'flightListImport',
  [BatchOperationType.FLIGHT_LIST_IMPORT_APM_PIPELINE]: 'flightListImportApm',
  [BatchOperationType.ROUTE_LIST_IMPORT_PIPELINE]: 'routeListImport',
  [BatchOperationType.CHANGESET_COMMIT]: 'changesetCommit',
  [BatchOperationType.REBUILD_DERIVED_DATA]: 'rebuildDerivedData',
  [BatchOperationType.DETECT_APPLICABLE_CHANGES]: 'detectChanges',
  [BatchOperationType.CALCULATE_STATUSES]: 'calculateStatuses',
};
